/**
 * ระดับชั้น — รหัสคงที่ · ป้ายไทยเป็นเรื่องแสดงผล (17 ก.ย. 2569)
 *
 * ★ ต้องตรงกับ `backend/app/core/grades.py` ทีละตัว — ถ้าส่งรหัสที่เซิร์ฟเวอร์ไม่รู้จัก
 *   จะได้ 422 ซึ่งดูเหมือนแอปพัง ป้ายที่แสดงจริงมาจาก `grade_label` ของ API
 *   รายการนี้ใช้แค่ตอน **เลือก** ในหน้าผู้ปกครอง
 */
export interface Grade {
  code: string
  label: string
}

export const GRADES: Grade[] = [
  { code: 'p1', label: 'ป.1' },
  { code: 'p2', label: 'ป.2' },
  { code: 'p3', label: 'ป.3' },
  { code: 'p4', label: 'ป.4' },
  { code: 'p5', label: 'ป.5' },
  { code: 'p6', label: 'ป.6' },
  { code: 'm1', label: 'ม.1' },
  { code: 'm2', label: 'ม.2' },
  { code: 'm3', label: 'ม.3' },
  { code: 'm4', label: 'ม.4' },
  { code: 'm5', label: 'ม.5' },
  { code: 'm6', label: 'ม.6' },
]
